import { createContext } from 'react'
import {
  AppliedCertificate,
  CertificateData,
  ExperienceVoucherCertificate,
} from '@big-red-group/storefront-common-checkout'

export type BookingContextData = {
  useRedemptionLayout: boolean
  certificates: ExperienceVoucherCertificate[]
  appliedEvs: number[]
}

export const BookingContext = createContext<BookingContextData>({
  useRedemptionLayout: false,
  certificates: [],
  appliedEvs: [],
})
BookingContext.displayName = 'BookingContext'
